import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Helmet from 'react-helmet';
import { FaSpinner } from 'react-icons/fa';
import { ChromePicker } from 'react-color';

import { primary_dark15, primary_light } from '../../shared/lib/colors';

import { loadProductsByCategory } from '../../../redux/modules/products';
import {
  getCategoryType,
  getCategoryName,
  getSubcategoryName,
  getCategoryDescription,
  getSubcategoryDescription,
} from '../../../redux/modules/categories';
import { changeColor } from '../../../redux/modules/store';
import connectDataFetchers from '../../shared/lib/connectDataFetchers.js';

import LeftFilters from '../../shared/LeftFilters/LeftFilters';
import Breadcrumb from '../../shared/Breadcrumb/Breadcrumb';
import Pager from '../../shared/Pager/Pager';
import ProductThumbnail from '../../shared/ProductThumbnail/ProductThumbnail';
import A from '../../shared/Anchor/Anchor';

import './Categoria.scss';
import { pushRemarketingEvent } from '../../shared/lib/gaEnhancedEcommerce';
import IubendaCookieSolution from '../../../utils/iubenda';
import { ga4ViewItemList } from '../../shared/lib/ga4EnhancedEcommerce';
import { fkmxViewItemList } from '../../shared/lib/farmakomMetrics';
import { getSHA256Hash } from '../../../utils/sha256';
import { ImageDispatcher } from '../../shared/ImageDispatcher/ImageDispatcher.js';
class Categoria extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showFilters: false,
    };
  }

  componentDidMount() {
    if (this.props.hasCriteo) {
      const iubenda = new IubendaCookieSolution(
        this.props.hasIubendaCookieSolution
      );
      iubenda.proceedIfHasConsent(() => this.renderCriteoTag());
    }

    // REMARKETING DINAMICO
    if (this.props.hasDynamicRemarketing) {
      pushRemarketingEvent('category');
    }

    // GA4 TRACK LIST
    if (this.props.hasGoogleAnalytics4Advanced) {
      this.ga4TrackItemsList();
    }

    // FKMX TRACK LIST
    if (this.props.hasFarmakomMetrics) {
      this.fkmxTrackItemsList();
    }
  }

  componentDidUpdate(oldProps) {
    if (this.props.loading !== oldProps.loading && !this.props.loading) {
      if (this.props.hasCriteo) {
        const iubenda = new IubendaCookieSolution(
          this.props.hasIubendaCookieSolution
        );
        iubenda.proceedIfHasConsent(() => this.renderCriteoTag());
      }

      // REMARKETING DINAMICO
      if (this.props.hasDynamicRemarketing) {
        pushRemarketingEvent('category');
      }

      // GA4 TRACK LIST
      if (this.props.hasGoogleAnalytics4Advanced) {
        this.ga4TrackItemsList();
      }

      // FKMX TRACK LIST
      if (this.props.hasFarmakomMetrics) {
        this.fkmxTrackItemsList();
      }
    }
  }

  ga4TrackItemsList = () => {
    const {
      products,
      categoryType,
      categoryName,
      subcategoryName,
    } = this.props;

    const listInfo = {
      id: `${categoryType}_${categoryName}${
        subcategoryName ? '_' + subcategoryName : ''
      }`,
      name: `${categoryType} > ${categoryName}${
        subcategoryName ? ' > ' + subcategoryName : ''
      }`,
    };

    ga4ViewItemList(products, listInfo);
  };

  fkmxTrackItemsList = () => {
    const {
      products,
      categoryType,
      categoryName,
      subcategoryName,
    } = this.props;

    const listInfo = {
      id: `${categoryType}_${categoryName}${
        subcategoryName ? '_' + subcategoryName : ''
      }`,
      name: `${categoryType} > ${categoryName}${
        subcategoryName ? ' > ' + subcategoryName : ''
      }`,
    };

    fkmxViewItemList(products, listInfo);
  };

  renderCriteoTag = () => {
    // <!-- Criteo Category / Search / Listing Tag -->
    const email = (this.props.user && this.props.user.email) || '';
    const zipcode =
      (this.props.user &&
        this.props.user.shipping &&
        this.props.user.shipping.zipcode) ||
      '';
    const productsList = this.props.products.map(prod => `"${prod.id}"`);

    // rimuovo il vecchio tag
    const oldTag = document.getElementById('criteo_listing_tag');
    if (oldTag) {
      document.body.removeChild(oldTag);
    }

    const criteo_listing_tag = document.createElement('script');
    criteo_listing_tag.id = 'criteo_listing_tag';
    criteo_listing_tag.type = 'text/javascript';
    criteo_listing_tag.innerHTML = `
        window.criteo_q = window.criteo_q || [];
        var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
        window.criteo_q.push(
        { event: "setAccount", account: ${this.props.criteoAccountId}},
        { event: "setEmail", email: "${getSHA256Hash(
          email
        )}", hash_method: "sha256" },
        { event: "setZipcode", zipcode: "${zipcode}" },
        { event: "setSiteType", type: deviceType},
        { event: "viewList", item: [${productsList.join(', ')}] });
    `;
    setTimeout(() => {
      document.body.appendChild(criteo_listing_tag);
    }, 200);
    // <!-- END Criteo Category / Search / Listing Tag -->
  };

  toggleFilters = event => {
    event.preventDefault();
    this.setState({
      showFilters: !this.state.showFilters,
    });
  };

  handleChangeColor = color => {
    this.props.changeColor(color.hex);
  };

  renderProducts(isMobile) {
    return (
      <div style={{ width: '100%' }}>
        {!isMobile && (
          <div className={'desktop'}>{this.renderProductsDesktop()}</div>
        )}
        {isMobile && (
          <div className={'mobile'}>{this.renderProductsMobile()}</div>
        )}
      </div>
    );
  }

  renderProductsDesktop = () => {
    const { categoryType, categoryName, subcategoryName } = this.props;

    const ga4ListInfo = {
      id: `${categoryType}_${categoryName}${
        subcategoryName ? '_' + subcategoryName : ''
      }`,
      name: `${categoryType} > ${categoryName}${
        subcategoryName ? ' > ' + subcategoryName : ''
      }`,
    };
    const productsConfiguration = this.props.homePageConfiguration.find(
      item => {
        if (item.moduleType === 'Products_carousel') {
          return item;
        }
        return;
      }
    );

    return (
      <div className={'desktop-container'}>
        {this.props.products.map(product => {
          return (
            <div
              className="col-sm-6 col-lg-4 col-xl-3"
              key={product.id}
              style={{ padding: 0 }}
            >
              <ProductThumbnail
                secondaryColor={this.props.secondaryColor}
                productsThumbnail={this.props.productsThumbnail}
                primaryColor={this.props.primaryColor}
                product={product}
                list="Categoria"
                ga4ListInfo={ga4ListInfo}
              />
            </div>
          );
        })}
      </div>
    );
  };

  renderProductsMobile = () => {
    const { categoryType, categoryName, subcategoryName } = this.props;

    const ga4ListInfo = {
      id: `${categoryType}_${categoryName}${
        subcategoryName ? '_' + subcategoryName : ''
      }`,
      name: `${categoryType} > ${categoryName}${
        subcategoryName ? ' > ' + subcategoryName : ''
      }`,
    };

    return (
      <div>
        <div className={'mobile-container'}>
          {this.props.products.map((product, index) => {
            return (
              <div style={{ width: '48%' }}>
                <ProductThumbnail
                  primaryColor={this.props.primaryColor}
                  secondaryColor={this.props.secondaryColor}
                  productsThumbnail={this.props.productsThumbnail}
                  key={product.id}
                  product={product}
                  list="Categoria"
                  spaceStar={6}
                  ga4ListInfo={ga4ListInfo}
                  lazy={index >= 4}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  render() {
    const { showFilters } = this.state;
    const { category, subcategory } = this.props.params;
    const {
      location,
      pagination,
      products,
      loading,
      categoryName,
      subcategoryName,
      categoryDescription,
      subcategoryDescription,
      siteName,
      siteUrl,
      logoImage,
      primaryColor,
      secondaryColor,
      linkDrugsAuthorizedSite,
      linkDrugsAuthorizedSiteVet,
      uiVariantButton,
    } = this.props;

    const capitalizeFirst = string =>
      string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();

    const showDrugsAuthorization = products.some(
      product =>
        product.taxCreditType === 'DRUG' ||
        product.taxCreditType === 'HOMEOPATHY'
    );

    const showDrugsVetAuthorization = products.some(
      product => product.taxCreditType === 'VETERINARY_DRUG'
    );

    return (
      <div className={`categoria ${showFilters ? 'filters-open' : ''}`}>
        <Helmet
          title={`${categoryName} ${subcategoryName}`}
          meta={[
            {
              name: 'description',
              content: `${siteName} - Ecommerce Farmacia vendita ${categoryName} ${subcategoryName}`,
            },
            {
              name: 'keywords',
              content: `${categoryName}, ${subcategoryName}, ${siteName}, ecommerce, farmacia`,
            },
            {
              name: 'robots',
              content: 'index, follow',
            },
            {
              property: 'og:title',
              content: `${siteName} - Ecommerce Farmacia vendita ${categoryName} ${subcategoryName}`,
            },
            { property: 'og:type', content: 'website' },
            {
              property: 'og:description',
              content: `${siteName} - Ecommerce Farmacia vendita online ${categoryName} ${subcategoryName}`,
            },
            { property: 'og:image', content: logoImage },
          ]}
          link={[
            {
              rel: 'canonical',
              href: `${siteUrl}/${this.props.categoryType.toLowerCase()}/${this.props.categoryType.toLowerCase()}-${(
                categoryName || ''
              )
                .toLowerCase()
                .replace(/\s+/g, '-')}${
                subcategoryName
                  ? `/${this.props.categoryType.toLowerCase()}_${(
                      subcategoryName || ''
                    )
                      .toLowerCase()
                      .replace(/\s+/g, '-')}`
                  : ''
              }`,
            },
          ]}
        />

        <div className="container">
          <LeftFilters
            category={category}
            subcategory={subcategory}
            location={location}
            sort={location.query.sort || 'sales'}
          />
          <div className="elenco-prodotti">
            <div className="pre-title">
              <A
                href="#"
                className="filter-toggle desktop"
                onClick={this.toggleFilters}
              >
                {showFilters ? 'Nascondi filtri' : 'Mostra filtri'}
              </A>

              <Breadcrumb
                page={this.props.categoryType}
                category={this.props.params.category}
                subcategory={this.props.params.subcategory}
              />

              {products.length > 0 && pagination.totalPages > 1 && (
                <Pager
                  location={location}
                  page={location.query.page || 1}
                  totalPages={pagination.totalPages}
                  primaryColor={primaryColor}
                  sort={location.query.sort || 'sales'}
                  uiVariantButton={uiVariantButton}
                />
              )}
            </div>

            <div
              className="page-title"
              style={{
                display: 'flex',
                alignItems: 'center',
                color: primary_dark15(primaryColor),
                backgroundColor: primary_light(primaryColor),
                borderRadius: 12,
              }}
            >
              <h1 style={{ fontSize: 20, fontWeight: 600, marginBottom: 0 }}>
                {capitalizeFirst(this.props.subcategoryName) ||
                  capitalizeFirst(this.props.categoryName)}
              </h1>
              {loading && (
                <span>
                  &nbsp;&nbsp;
                  <FaSpinner className="pulse" />
                </span>
              )}

              {showDrugsAuthorization && !!linkDrugsAuthorizedSite && (
                <div>
                  <a
                    className="store-authorized-link"
                    href={linkDrugsAuthorizedSite}
                    target="_blank"
                    aria-label="Link all'autorizzazione ministeriale della farmacia"
                  >
                    <ImageDispatcher
                      src="/static/images/logo_farmacia_autorizzata.png"
                      style={{ width: 60 }}
                      alt="Logo farmacia autorizzata"
                    />
                  </a>
                </div>
              )}
              {showDrugsVetAuthorization && !!linkDrugsAuthorizedSiteVet && (
                <div>
                  <a
                    className="store-authorized-link"
                    href={linkDrugsAuthorizedSiteVet}
                    target="_blank"
                    aria-label="Link all'autorizzazione ministeriale della farmacia"
                  >
                    <ImageDispatcher
                      src="/static/images/logo_farmacia_autorizzata_vet.png"
                      style={{ width: 60 }}
                      alt="Logo farmacia autorizzata"
                    />
                  </a>
                </div>
              )}
            </div>

            {(!!subcategoryDescription || !!categoryDescription) && (
              <div className="category-description">
                {subcategoryDescription || categoryDescription}
              </div>
            )}

            <div className="row">
              {this.renderProducts(this.props.isMobile)}
            </div>

            {pagination.totalPages > 1 && (
              <Pager
                location={location}
                page={location.query.page || 1}
                totalPages={pagination.totalPages}
                primaryColor={primaryColor}
                sort={location.query.sort || 'sales'}
                uiVariantButton={uiVariantButton}
                isNew
              />
            )}

            {!loading && products.length === 0 && (
              <div className="no-results">
                <p>Nessun prodotto trovato in questa categoria.</p>
                <p>Prova a ricercare per parole chiave.</p>
              </div>
            )}
            <div className="clearfix" />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    isMobile: state.layout.isMobile,
    user: state.user.data,
    categoryType: getCategoryType(state, ownProps.params.category),
    categoryName: getCategoryName(state, ownProps.params.category),
    subcategoryName: getSubcategoryName(state, ownProps.params.subcategory),
    categoryDescription: getCategoryDescription(
      state,
      ownProps.params.category
    ),
    subcategoryDescription: getSubcategoryDescription(
      state,
      ownProps.params.subcategory
    ),
    pagination: state.products.pagination,
    products: state.products.data,
    loading: state.products.loading,
    siteName: state.store.data.datiFarmacia.siteName,
    siteUrl: state.store.data.datiFarmacia.siteUrl,
    logoImage: state.store.data.loghiTemplate.logoImage,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    secondaryColor: state.store.data.loghiTemplate.secondaryColor,
    uiVariantButton: state.store.data.uiVariants.buttons,
    linkDrugsAuthorizedSite:
      state.store.data.datiFarmacia.linkDrugsAuthorizedSite,
    linkDrugsAuthorizedSiteVet:
      state.store.data.datiFarmacia.linkDrugsAuthorizedSiteVet,
    hasCriteo: state.store.data.features.hasCriteo,
    hasDynamicRemarketing: state.store.data.features.hasDynamicRemarketing,
    hasIubendaCookieSolution:
      state.store.data.features.hasIubendaCookieSolution,
    criteoAccountId: state.store.data.integrazioni.criteo.accountId,
    hasGoogleAnalytics4Advanced: !!state.store.data.features
      .hasGoogleAnalytics4Advanced,
    hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
    homePageConfiguration: state.store.data.home.homePageConfiguration,
    productsThumbnail: state.store.data.home.visualVariants.thumbnailProduct,
  };
}

export default withRouter(
  connect(null, { changeColor })(
    connect(mapStateToProps)(
      connectDataFetchers(Categoria, [loadProductsByCategory])
    )
  )
);
